import React, { forwardRef, ReactNode } from 'react'
import CustomIcons from '../../../../ui_reusable/CustomIcons'
import theme from '../../../../../styles/theme'
import {
  Container,
  HeaderContainer,
  TitleContainer,
  Title,
  Overview,
  ButtonContainer,
  IconButton,
  Divider,
  ContentContainer,
} from './styles/ReportSubSection.styles'

interface ReportSubSectionProps {
  /** Section title */
  title: string
  /** Grey text description below title */
  overviewText?: string
  /** Content to be rendered below divider */
  children: ReactNode
}

/**
 * Template component for Report subsections
 */
const ReportSubSection = forwardRef<HTMLDivElement, ReportSubSectionProps>(
  ({ title, overviewText, children }, ref) => {
    return (
      <Container ref={ref}>
        <HeaderContainer>
          <TitleContainer>
            <Title>{title}</Title>
            {overviewText && <Overview>{overviewText}</Overview>}
          </TitleContainer>
          <ButtonContainer>
            <IconButton>
              <CustomIcons.CirclePlusThickIcon
                size="small"
                color={theme.colors.fancyText}
              />
            </IconButton>
            <IconButton>
              <CustomIcons.ShareThickIcon
                size="small"
                color={theme.colors.fancyText}
              />
            </IconButton>
          </ButtonContainer>
        </HeaderContainer>
        <Divider />
        <ContentContainer>{children}</ContentContainer>
      </Container>
    )
  },
)

ReportSubSection.displayName = 'ReportSubSection'

export default ReportSubSection
